export function logError(errorOrMessage) {
  window.Rollbar && window.Rollbar.error(errorOrMessage);
}
